<template>  
  <div class="orderEvaluate">
    <XR-head titleText="订单评价"></XR-head>
    <div class="form" v-if="!loaded">
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
        <div class="remark">      
          <mu-text-field  label="商品名称" v-model="productName" disabled fullWidth />
        </div>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <div class="evaStar">
            <mu-icon-button icon=":fa fa-star" v-for="(itemClass,index) in itemClasses" :class="itemClass" :key="index" class="star-item" @click="stars(index)"></mu-icon-button><!--性能优化 track-by 数据不改变时不会重新渲染-->
          </div>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
        <div class="remark">      
          <mu-text-field  label="评价" hintText="请输入您要评价的内容" multiLine :rows="3" :rowsMax="6" :maxLength="50" v-model="evaluateInfo.PjContent" fullWidth />
        </div>
        </mu-col>
      </mu-row>
      <mu-row>
        <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <div class="weui-uploader">
                <div class="weui-uploader__hd">
                  <p class="weui-uploader__title">图片上传</p>
                  <div class="weui-uploader__info">{{evaluateInfo.Images.length}}/5</div>
                </div>
                <div class="weui-uploader__bd">
                  <ul class="weui-uploader__files" id="uploaderFiles">
                    <template v-for="imgItem in evaluateInfo.Images">
                      <li class="weui-uploader__file weui-uploader__file_status" :key="imgItem.ImgPath" :style="{backgroundImage:'url('+imgItem.ImgPath+')'}">
                        <div class="weui-uploader__file-content" @click="removeImg(imgItem)">
                          <i class="fa fa-delete"></i>
                        </div>
                      </li>
                    </template>
                    <li  class="weui-uploader__input-box" v-if="evaluateInfo.Images.length<5">                      
                      <input id="uploaderInput" class="weui-uploader__input" type="file" ref="uploadImg"  @change="uploadImageMethod">    
                      <!-- accept="image/png,image/gif,image/jpeg"                -->
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="button-row">
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="sellServiceOrderMsg()" />
        </mu-col>
      </mu-row>
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded:true,
      itemId: this.$route.query.itemId,
      evaluateInfo: {
        SkuId: this.$route.query.skuId,
        OrderNumber: this.$route.query.orderNumber,
        StarLevel:0,
        PjContent: "",
        Images:[]
      },
      orderItemInfo:[],
      productName:'',
      userInfo: {}
    };
  },
  created: function () {
    window.orderEvaluteUploadImageResultAndroid = this.orderEvaluteUploadImageResultAndroid
  },
  mounted() {
    this.$refs.XRtoast.load('加载中...')
    this.getOrderItem()
  },
  methods: {    
    getUserInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){
          ths.loaded = false
          ths.$refs.XRtoast.hide()
          ths.userInfo = res.Data
        }
      });
    },
    getOrderItem(){
      var ths = this;
      ths
        .$post(
          "/Shop/PinTuanServer/WapOrderGetInfoById", {id:this.itemId}
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.orderItemInfo = res.Data
            ths.productName = ths.orderItemInfo.Fname + ' '
            if(ths.orderItemInfo.Fsuborder[0].Fattr){
              ths.productName += ths.orderItemInfo.Fsuborder[0].Fattr
            }
            ths.getUserInfo()
          }
        });
    },
    sellServiceOrderMsg() {
      var ths = this;
      ths
        .$post(
          "/Shop/PinTuanServer/OrderItemEvaluate", this.evaluateInfo
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.$refs.XRtoast.success(res.Msg, true);
          }
        });
    },
    goBack() {
      this.$router.goBack();
    },
    stars: function(index) {
      this.evaluateInfo.StarLevel = index + 1;
    },
    uploadImageMethod(e){
      if(this.memberId <=0){
          this.$refs.XRtoast.failed('您未登录', true)
          return
      }
      
      this.$refs.XRtoast.load('正在上传...', false)
      let file = e.target.files[0]; 
      if(!file || !file.name){
          this.$refs.uploadImg.value=''
          this.$refs.XRtoast.failed('上传失败，请重试', true)
          return
      }
      if (file.type){
      if(!/image\/\w+/.test(file.type)){ 
        this.$refs.uploadImg.value=''
        this.$refs.XRtoast.failed('文件必须为图片！', true)
        return false; 
      }
      }	  
      if ((file.size / 1024 / 1024 ).toFixed(2) > 4) {
        this.$refs.uploadImg.value=''
        this.$refs.XRtoast.failed('不允许超过4M！', true)
        return false;
      }
      
      let param = new FormData(); //创建form对象
      param.append('file',file);//通过append向form对象添加数据
      param.append('filename',file.name);
      param.append('path','product');
      param.append('userid',this.userInfo.Id)
      //console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };  //添加请求头

      var ths = this
      this.$post('/Shop/RetailServer/UploadEvaluateImage',param,config)
      .then(function(res){
        ths.$refs.XRtoast.hide()
        ths.$refs.uploadImg.value=''
        if(res.IsSuccess){
          ths.evaluateInfo.Images.push({ImgPath:res.Data})
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
      })        
    },
    removeImg(imgItem){
      var imgList = []
      for(var i = 0 ; i< this.evaluateInfo.Images.length; i++){
        var imgEntity = this.evaluateInfo.Images[i]
        if(imgEntity.ImgPath == imgItem.ImgPath){
          continue
        }
        imgList.push(imgEntity)
      }
      this.evaluateInfo.Images = imgList
    },
  },
  computed: {
    itemClasses() {
      let result = []; // 返回的是一个数组,用来遍历输出星星
      let score = Math.floor(this.evaluateInfo.StarLevel * 2) / 2; // 计算所有星星的数量
      let hasDecimal = score % 1 !== 0; // 非整数星星判断
      let integer = Math.floor(score); // 整数星星判断
      for (let i = 0; i < integer; i++) {
        // 整数星星使用on
        result.push("on"); // 一个整数星星就push一个CLS_ON到数组
      }
      if (hasDecimal) {
        // 非整数星星使用half
        result.push("half"); // 类似
      }
      while (result.length < 5) {
        // 余下的用无星星补全,使用off
        result.push("off");
      }
      return result;
    }
  }
};
</script>

<style>
.orderEvaluate .form {
  background: white;
  padding: 10px;
}
.orderEvaluate .remark {
  background: white;
}
.orderEvaluate .button-row {
  padding: 40px 20px 40px 20px;
}
.orderEvaluate .submit {
  height: 50px;
}

.orderEvaluate .evaStar {
  padding: 30px 0;
  text-align: center;
}
.orderEvaluate .evaStar .star-item {
  font-size: 12px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  padding: 3px;
  margin: 0;
  color:#ccc;
}
.orderEvaluate .evaStar .star-item.on{
  color:red;
}


.orderEvaluate .weui-cells {
  background-color: #FFFFFF;
  line-height: 1.47058824;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}
.orderEvaluate .weui-cell {
  padding: 10px 15px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.orderEvaluate .weui-cell__bd {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.orderEvaluate .weui-uploader__hd {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    padding-bottom: 10px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}
.orderEvaluate .weui-uploader__title {
  padding-right: 10px;
}
.orderEvaluate .weui-uploader__info {
    color: #B2B2B2;
}
.orderEvaluate .weui-uploader__bd {
    margin-bottom: -4px;
    margin-right: -9px;
    overflow: hidden;
}
.orderEvaluate .weui-uploader__files {
    list-style: none;
}
.orderEvaluate .weui-uploader__file {
    float: left;
    margin-right: 9px;
    margin-bottom: 9px;
    width: 79px;
    height: 79px;
    background: no-repeat center center;
    background-size: cover;
}
.orderEvaluate .weui-uploader__file_status {
    position: relative;
}
.orderEvaluate .weui-uploader__file_status:before {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
.orderEvaluate .weui-uploader__file_status .weui-uploader__file-content {
    display: block;
}
.orderEvaluate .weui-uploader__file-content {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: #FFFFFF;
}
.orderEvaluate .weui-uploader__file-content .weui-icon-warn {
    display: inline-block;
}

.orderEvaluate .weui-uploader__input-box {
    float: left;
    position: relative;
    margin-right: 9px;
    margin-bottom: 9px;
    width: 79px;
    height: 79px;
    border: 1px solid #D9D9D9;
}
.orderEvaluate .weui-uploader__input {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.orderEvaluate .weui-uploader__input-box:before {
    width: 2px;
    height: 39.5px;
}
.orderEvaluate .weui-uploader__input-box:before, .weui-uploader__input-box:after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #D9D9D9;
}
.orderEvaluate .weui-uploader__input-box:after {
    width: 39.5px;
    height: 2px;
}
.orderEvaluate .weui-uploader__input-box:before, .weui-uploader__input-box:after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #D9D9D9;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/pintuanOrderEvaluate.vue